import { createSlice, WithSlice } from '@reduxjs/toolkit';
import { rootReducer } from '@ui/store';
import type { WritableDraft } from 'immer';

import { initialState, type SnapSiteConfigState } from './initial-state';
import * as reducers from './reducers';

const SNAP_SITE_CONFIG_SLICE_NAME = 'snapSiteConfig';

const snapSiteConfigSlice = createSlice({
  name: SNAP_SITE_CONFIG_SLICE_NAME,
  initialState,
  reducers,
  selectors: {
    selectCurrentSite: (state: SnapSiteConfigState) => state,
    selectSnapSiteConfig: (state: SnapSiteConfigState) => state.snapSiteConfig,
  },
});

const injectedSnapSiteConfigSlice = snapSiteConfigSlice.injectInto(rootReducer);

export const {
  actions: snapSiteConfigActions,
  selectors: snapSiteConfigSelectors,
} = injectedSnapSiteConfigSlice;

export type WritableSnapSiteConfigStore = WritableDraft<SnapSiteConfigState>;

declare module '@ui/store' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface LazyLoadedSlices
    extends WithSlice<typeof snapSiteConfigSlice> {}
}
